module.exports = __webpack_public_path__ + "img/54.d608ce39.jpg";